import { put, call, takeLatest } from "redux-saga/effects";

import * as Actions from "../actions/Client";
import * as Types from "../constants/Client";

import ClientService from "services/ClientService";


export function* fetchClientsEffect() {
    try {
        console.log("FETCHING ALL CLIENTS");
        const { data: clients } = yield call(ClientService.fetchAll);
        yield (put(Actions.fetchClientsOk(clients.result)));
    } catch ({ response }) {
        yield (
            put(
                Actions.fetchClientsFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: []
                })
            )
        );
    }
}

export function* addClientEffect({ payload }) {
    try {
        yield call(ClientService.postClient, payload);
        yield (put(Actions.addClientOk()));
    } catch (error) {

        const { status, data: errorContent } = error.response.data;
        const hasErrors = errorContent !== null && errorContent.errors;
        yield (
            put(
                Actions.addClientFailed({
                    status,
                    message: errorContent.message,
                    errors: hasErrors ? errorContent.errors : [],
                })
            )
        );
    }
}


export function* fetchClientEffect({ payload }) {
    try {
        const { data: client } = yield call(ClientService.fetchClient, payload);
        yield (put(Actions.fetchClientIdOk(client)));
    } catch ({ response }) {
        yield (
            put(
                Actions.fetchClientIdFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: []
                })
            )
        );
    }
}

export function* patchClientEffect({ payload }) {
    try {
        yield call(ClientService.patchClient, payload);
        yield (put(Actions.patchClientOk()));
    } catch (error) {
        const { status, data: errorContent } = error.response.data;
        const hasErrors = errorContent !== null && errorContent.errors;

        yield (
            put(
                Actions.patchClientFailed({
                    status,
                    message: errorContent.message,
                    errors: hasErrors ? errorContent.errors : [],
                })
            )
        );
    }
}

export default function* rootSaga() {
    yield takeLatest(Types.FETCH_CLIENTS, fetchClientsEffect);
    yield takeLatest(Types.ADD_CLIENT, addClientEffect);
    yield takeLatest(Types.PATCH_CLIENT, patchClientEffect);
    yield takeLatest(Types.FETCH_CLIENT_ID, fetchClientEffect);
}
